import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Markdown from "@/components/Markdown";
import Mindmap from "@/components/Mindmap";
import VideoPlayer from "@/components/VideoPlayer";
import MiroEmbed from "@/components/MiroEmbed";
import Flashcards from "@/components/Flashcards";
import { FileText, Network, PlayCircle, PenTool, Layers } from "lucide-react";

const trig = "data-[state=active]:bg-emerald-500/15 data-[state=active]:text-emerald-400 rounded-lg gap-2 text-slate-400 text-sm";

export default function MaterialViewer({ material }) {
  return (
    <Tabs defaultValue="video" className="w-full">
      <TabsList className="bg-[#090D16] border border-[#1E293B] p-1 rounded-xl flex-wrap h-auto">
        <TabsTrigger value="video" data-testid="tab-video" className={trig}><PlayCircle className="w-4 h-4" /> Recording</TabsTrigger>
        <TabsTrigger value="notes" data-testid="tab-notes" className={trig}><FileText className="w-4 h-4" /> Notes</TabsTrigger>
        <TabsTrigger value="cards" data-testid="tab-flashcards" className={trig}><Layers className="w-4 h-4" /> Flashcards</TabsTrigger>
        <TabsTrigger value="mindmap" data-testid="tab-mindmap" className={trig}><Network className="w-4 h-4" /> Mindmap</TabsTrigger>
        <TabsTrigger value="board" data-testid="tab-board" className={trig}><PenTool className="w-4 h-4" /> Board</TabsTrigger>
      </TabsList>

      <TabsContent value="video" className="mt-4"><VideoPlayer url={material.video_url} /></TabsContent>

      <TabsContent value="notes" className="mt-4">
        <div className="rounded-2xl border border-[#1E293B] bg-[#090D16] p-6 max-h-[480px] overflow-y-auto">
          <Markdown>{material.notes_md}</Markdown>
        </div>
      </TabsContent>

      <TabsContent value="cards" className="mt-4"><Flashcards notes={material.notes_md} /></TabsContent>

      <TabsContent value="mindmap" className="mt-4"><Mindmap data={material.mindmap_json} /></TabsContent>

      <TabsContent value="board" className="mt-4"><MiroEmbed url={material.miro_url} /></TabsContent>
    </Tabs>
  );
}
